import React from 'react';
import { Button } from '../../ui';

interface NavigationControlsProps {
  currentIndex: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  currentIndex,
  total,
  onPrev,
  onNext,
}) => (
  <div className="flex items-center justify-center gap-6 mt-3">
    <Button
      size="sm"
      variant="ghost"
      onClick={onPrev}
      disabled={currentIndex === 0}
      className="font-mono text-xs text-zinc-400 hover:text-zinc-200 uppercase tracking-wider disabled:opacity-30 disabled:hover:text-zinc-400"
    >
      Prev
    </Button>
    <div className="flex gap-1.5">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`w-1.5 h-1.5 rounded-full transition-colors ${
            i === currentIndex ? 'bg-zinc-300' : 'bg-white/20'
          }`}
        />
      ))}
    </div>
    <Button
      size="sm"
      variant="ghost"
      onClick={onNext}
      disabled={currentIndex === total - 1}
      className="font-mono text-xs text-zinc-400 hover:text-zinc-200 uppercase tracking-wider disabled:opacity-30 disabled:hover:text-zinc-400"
    >
      Next
    </Button>
  </div>
);

export default NavigationControls;